import React from 'react'
import CheckboxElement from './Checkbox'
import DateElement from './DateElement'
import DurationElement from './DurationElement'
import { ElementType, FormElementProps } from './FormElementParts'
import InputElement from './InputElement'
import RadioElement from './RadioElement'
import SelectElement from './SelectElement'
import SwitchElement from './Switch'
import TextareaElement from './TextareaElement'

const FormElementFactory: React.FC<FormElementProps> = props => {
  const { type } = props

  switch (type) {
    case ElementType.CHECKBOX:
      return <CheckboxElement {...props} />
    case ElementType.DATE:
      return <DateElement {...props} />
    case ElementType.DURATION:
      return <DurationElement {...props} />
    case ElementType.EMAIL:
    case ElementType.PASSWORD:
    case ElementType.TEL:
    case ElementType.TEXT:
    case ElementType.ZIP:
      return <InputElement {...props} />
    case ElementType.RADIO:
      return <RadioElement {...props} />
    case ElementType.TEXTAREA:
      return <TextareaElement {...props} />
    case ElementType.SELECT:
      return <SelectElement {...props} />
    case ElementType.SWITCH:
      return <SwitchElement {...props} />
    default:
      return null
  }
}

export default FormElementFactory
